<template>
  <div>
    <div class="navigator" id="navigator">
      <el-row :gutter="20" class="navigator_content">
        <el-col :xs="6" :sm="6" :md="6" :lg="6" :xl="6" class="navigator-logo">
          <img :src="logo" width="220px" />
        </el-col>
        <el-col :xs="18" :sm="18" :md="18" :lg="18" :xl="18">
          <el-menu
            class="navigator-menu"
            mode="horizontal"
            :default-active="activeIndex"
            background-color="inherit"
            text-color="#D9D9D9"
            active-text-color="#fff"
          >
            <el-menu-item index="1">
              <router-link
                to="/"
                @mouseover.native="productTable = false,solutionTable = false"
              >首页</router-link>
            </el-menu-item>
            <el-menu-item
              index="2"
              v-bind:style="{background:$route.name == 'solution'?'rgba(255, 255, 255, 0.1) !important':'transparent'}"
            >
              <div
                v-bind:style="{fontWeight:$route.name == 'solution'?'bold':'200'}"
                style="color: #fff;line-height: 76px"
                @mouseleave="solutionTable = true"
                @mouseover="solutionTable = true,productTable = false"
              >解决方案</div>
            </el-menu-item>
            <el-menu-item
              index="3"
              v-bind:style="{background:$route.name == 'product'?'rgba(255, 255, 255, 0.1) !important':'transparent'}"
            >
              <div
                v-bind:style="{fontWeight:$route.name == 'solution'?'bold':'200'}"
                style="color: #fff;line-height: 76px"
                @mouseleave="productTable = true"
                @mouseover="productTable = true,solutionTable = false"
              >产品与服务</div>
            </el-menu-item>
            <el-menu-item v-for="(item, index) in menuItems" :key="index" :index="item.index">
              <router-link
                :to="item.url"
                @mouseover.native="productTable = false,solutionTable = false"
              >{{item.title}}</router-link>
            </el-menu-item>
            <el-menu-item index="5">
              <a href="#business" @mouseover="productTable = false,solutionTable = false">商务合作</a>
            </el-menu-item>
            <el-menu-item index="6" class="register_button">
              <router-link
                to="/register/sealRegister"
                @mouseover="productTable = false,solutionTable = false"
              >免费注册</router-link>
            </el-menu-item>
            <el-menu-item index="7" class="login_button">
              <div v-if="isLogging" @click="logout" class="logout">
                <span>退出登录</span>
                <i class="logout-icon"></i>
              </div>
              <router-link
                v-else
                to="/login"
                @mouseover="productTable = false,solutionTable = false"
              >登录</router-link>
            </el-menu-item>
          </el-menu>
        </el-col>
      </el-row>
    </div>
    <div
      class="doc_nav"
      v-if="solutionTable"
      v-bind:style="{left:nav_left+'px'}"
      @mouseover="solutionTable = true"
      @mouseleave="solutionTable = false"
    >
      <div class="nav_content_left" v-bind:style="{borderRight:key==0?'0':'1px solid #666'}">
        <p
          class="nav_col"
          v-bind:class="{'active':index==key}"
          v-for="(navItem,index) in navItems"
          :key="index"
          @click="whichNav(navItem,index)"
          @mouseover="whichNav(navItem,index)"
        >
          {{navItem.name}}
          <i
            class="el-icon-arrow-right"
            v-if="index==key"
            style="float: right;margin: 13px 0;width: 4px;"
          ></i>
        </p>
      </div>
      <div
        class="nav_content_right"
        v-bind:style="{maxWidth: max_width+'px',borderLeft:key==0?'1px solid #666':'0'}"
      >
        <div class="nav_col" v-for="(item,idx) in items" :key="idx">
          <p>{{item.type}}</p>
          <div
            class="nav_col_list"
            v-for="(list,index) in item.lists"
            :key="index"
            @click="whichSolution(list)"
          >{{list.name}}</div>
        </div>
      </div>
    </div>

    <div
      class="doc_nav"
      v-if="productTable"
      v-bind:style="{left:nav_left_1+'px'}"
      @mouseover="productTable = true"
      @mouseleave="productTable = false"
    >
      <div
        class="nav_content_left"
        v-bind:style="{borderRight:key==2||key==3?'0':'1px solid #666'}"
      >
        <p
          class="nav_col"
          v-bind:class="{'active':index==key}"
          v-for="(navItem,index) in productMenuItems"
          :key="index"
          @click="whichNav_1(navItem,index)"
          @mouseover="whichNav_1(navItem,index)"
        >
          {{navItem.name}}
          <i
            class="el-icon-arrow-right"
            v-if="index==key"
            style="float: right;margin: 13px 0;width: 4px;"
          ></i>
        </p>
      </div>
      <div
        class="nav_content_right"
        v-bind:style="{maxWidth: max_width_1+'px',width: '540px',borderLeft:key==2||key==3?'1px solid #666':'0'}"
      >
        <div class="nav_col" v-for="(item,idx) in productItems" :key="idx">
          <div
            class="nav_col_list"
            v-for="(list,index) in item.lists"
            :key="index"
            @click="highlightMenu"
          >
            <router-link :to="{path: '/product#'+list.hash}">{{list.name}}</router-link>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ElCol from "element-ui/packages/col/src/col";
import ElRow from "element-ui/packages/row/src/row";
import Bus from "../assets/bus.js";
import logo from "../assets/img/logo2x.png";

export default {
  name: "Navigator",
  components: {
    ElRow,
    ElCol
  },
  mounted() {
    this.nav_left = document
      .getElementsByClassName("el-menu-item")[1]
      .getBoundingClientRect().left;
    this.nav_left_1 = document
      .getElementsByClassName("el-menu-item")[2]
      .getBoundingClientRect().left;
    this.max_width =
      window.document.documentElement.clientWidth - this.nav_left - 180;
    this.max_width_1 =
      window.document.documentElement.clientWidth - this.nav_left_1 - 180;
    this.items = this.navItems[0].items;
    this.productItems = this.productMenuItems[0].items;
    this.isLogging = JSON.parse(window.sessionStorage.getItem("user"));
  },
  data() {
    return {
      logo: logo,
      key: 0,
      solutionTable: false,
      productTable: false,
      items: [],
      nav_left: 0,
      nav_left_1: 0,
      max_width: 0,
      max_width_1: 0,
      menuItems: [
        {
          title: "技术方案",
          url: "/technology",
          index: "4"
        }
      ],
      navItems: [
        {
          name: "金融服务",

          items: [
            {
              type: "客服",
              lists: [
                {
                  name: "E1 智能电话客服整体解决方案",
                  hash: "E1"
                },
                {
                  name: "E2 视频报案查勘解决方案",
                  hash: "E2"
                },
                {
                  name: "E3 智能视频客服解决方案",
                  hash: "E3"
                },
                {
                  name: "E4 知识管理整体解决方案",
                  hash: "E4"
                },
                {
                  name: "E5 智能文本机器人解决方案",
                  hash: "E5"
                }
              ]
            },
            {
              type: "催收",
              lists: [
                {
                  name: "E6 智能催收整体解决方案",
                  hash: "E6"
                }
              ]
            },
            {
              type: "信审",
              lists: [
                {
                  name: "E7 智能信审解决方案",
                  hash: "E7"
                }
              ]
            },
            {
              type: "电销",
              lists: [
                {
                  name: "E8 电销外呼解决方案",
                  hash: "E8"
                }
              ]
            }
          ]
        },
        {
          name: "门店服务",

          items: [
            {
              type: "接待指引",
              lists: [
                {
                  name: "E9 门店智能服务终端解决方案",
                  hash: "E9"
                }
              ]
            },
            {
              type: "业务办理",
              lists: [
                {
                  name: "E10 智能一体机解决方案",
                  hash: "E10"
                }
              ]
            }
          ]
        },
        {
          name: "城市服务",

          items: [
            {
              type: "交通",
              lists: [
                {
                  name: "E11 智慧交通市民服务整体解决方案",
                  hash: "E11"
                }
              ]
            }
          ]
        },
        {
          name: "企业管理及员工服务",

          items: [
            {
              type: "风控",
              lists: [
                {
                  name:
                    "E12 企业内部核心风控整体解决方案（采购、法务、印章、财务）",
                  hash: "E12"
                },
                {
                  name: "E13 员工HR智能服务解决方案",
                  hash: "E13"
                }
              ]
            }
          ]
        },
        {
          name: "通用服务",

          items: [
            {
              type: "",
              lists: [
                {
                  name: "E14 智能回访解决方案",
                  hash: "E4"
                },
                {
                  name: "E15 智能话机解决方案",
                  hash: "E15"
                },
                {
                  name: "E16 智能标注及训练整体解决方案",
                  hash: "E16"
                }
              ]
            }
          ]
        }
      ],
      productMenuItems: [
        {
          name: "平台",
          items: [
            {
              type: "",
              lists: [
                {
                  name: "A1 一站式数字电话平台服务",
                  hash: "A1"
                },
                {
                  name: "A2 智能电话机",
                  hash: "A2"
                },
                {
                  name: "A3 一站式多媒体视频平台服务",
                  hash: "A3"
                },
                {
                  name: "A4 智能一体化",
                  hash: "A4"
                }
              ]
            }
          ]
        },
        {
          name: "系统",
          items: [
            {
              type: "",
              lists: [
                {
                  name: "B1 通用系统",
                  hash: "B1"
                },
                {
                  name: "B2 催收系统",
                  hash: "B2"
                },
                {
                  name: "B3 通用电销系统",
                  hash: "B3"
                }
              ]
            }
          ]
        },
        {
          name: "智能应用",
          items: [
            {
              type: "",
              lists: [
                {
                  name: "C1 智能知识平台",
                  hash: "C1"
                },
                {
                  name: "C2 智能座席助手",
                  hash: "C2"
                },
                {
                  name: "C3 电话客服实时监控(情绪/话术)",
                  hash: "C3"
                },
                {
                  name: "C4 智能质检系统",
                  hash: "C4"
                },
                {
                  name: "C5 智能语音交互",
                  hash: "C5"
                },
                {
                  name: "C6 印章管理平台",
                  hash: "C6"
                },
                {
                  name: "C7 文本机器人",
                  hash: "C7"
                },
                {
                  name: "C8 智能消息",
                  hash: "C8"
                },
                {
                  name: "C9 超级微视频",
                  hash: "C9"
                },
                {
                  name: "C10 智能弹屏",
                  hash: "C10"
                },
                {
                  name: "C11 智能语义标注平台",
                  hash: "C11"
                },
                {
                  name: "C12 智能语音标注平台",
                  hash: "C12"
                },
                {
                  name: "C13 智能财务合同风控及标注平台",
                  hash: "C13"
                },
                {
                  name: "C14 电子签章平台",
                  hash: "C14"
                },
                {
                  name: "C15 智能门店服务机器人",
                  hash: "C15"
                },
                {
                  name: "C16 柜面客户满意度分析机器人",
                  hash: "C16"
                }
              ]
            }
          ]
        },
        {
          name: "人力外包",
          items: [
            {
              type: "",
              lists: [
                {
                  name: "D1 电话座席",
                  hash: "D1"
                },
                {
                  name: "D2 视频座席",
                  hash: "D2"
                },
                {
                  name: "D3 人工语音标注(音转字、语音情绪等)",
                  hash: "D3"
                },
                {
                  name: "D4 人工语义标注(智能语音、文本机器人应用等)",
                  hash: "D4"
                },
                {
                  name: "D5 合同及文档语义标注",
                  hash: "D5"
                },
                {
                  name: "D6 知识梳理",
                  hash: "D6"
                }
              ]
            }
          ]
        }
      ],
      activeIndex: "1",
      isLogging: false
    };
  },
  methods: {
    whichNav: function(nav, index) {
      this.items = nav.items;

      this.key = index;
    },
    whichNav_1: function(nav, index) {
      this.productItems = nav.items;

      this.key = index;
    },
    whichSolution: function(list) {
      if (this.$route.name == "solution")
        Bus.$emit("hash_solution", {
          //current route not change
          subKey: list.hash,
          activeName: this.key
        });
      else
        this.$router.push({
          name: "solution",
          params: {
            subKey: list.hash,
            activeName: this.key
          }
        });

      this.solutionTable = false;
      this.activeIndex = "2";
    },
    highlightMenu: function() {
      this.activeIndex = "3";
    },
    logout() {
      this.$api.common.logout().then(() => {
        this.toLogin();
      });
    },
    toLogin() {
      window.sessionStorage.removeItem("user");
      this.$router.push({
        name: "login"
      });
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/Navigator.vue